import React from "react";
import classes from "./Header.module.scss";
import Link from "next/link";
import SearchMoreContainer from "./SearchMoreContainer/SearchMoreContainer";
import HeaderDropdown from "./HighEmittingDropdown/HeaderDropdown";
import headerLinks from "./config/headerLinks";
import { DropdownProvider } from "./HighEmittingDropdown/HeaderDropdownContext/HeaderDropdownContext";
import NgAiLogo from "./NgAiLogo/NgAiLogo";
import RadioButton from "../RadioButton/RadioButton";
import AuthLink from "./AuthLink";


type Props = {
  className?: string;
};

const Header = ({ className }: Props) => {
  return (
    <div className={`${classes["header-container"]} ${className}`}>
      <div className={classes["top-container"]}>
        <Link href="/" aria-label="Go to Home">
          <NgAiLogo aria-hidden="true" />
        </Link>

        <div className={classes["top-container-btn-section"]}>
          <RadioButton className={classes["radio-button"]} />

          <AuthLink />
        </div>
      </div>

      <div className={classes["separator"]}></div>

      <div className={classes["bottom-container"]}>
        {
          <div className={classes["links-container"]}>
            {headerLinks.map((ele, index) => (
              <React.Fragment key={ele.title}>
                {ele.isDropdown ? (
                  <DropdownProvider>
                    <HeaderDropdown
                      dropdownName={ele.title}
                      options={ele.option}
                    />
                  </DropdownProvider>
                ) : (
                  <Link
                    key={index}
                    href={ele.link}
                    className={classes["link-element"]}
                  >
                    {ele.title}
                  </Link>
                )}
              </React.Fragment>
            ))}
          </div>
        }
        {/* Wrapper for CEOsColumn and SearchMoreContainer */}
        <div className={classes["search-wrapper"]}>
          <Link className={classes["ceos-menu"]} href="/ceos-column">CEO&apos;s Column</Link>
          <SearchMoreContainer />
        </div>
      </div>
    </div>
  );
};

export default Header;
